import Grid from "@mui/material/Grid";
import { GridColDef, DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ErrorOverlay from "../../../components/ErrorOverlay";
import NoRecords from "../../../components/NoRecords";
import { loadingAllAllergies } from "../../../Redux/Slice/AllergiesSlice";
import { ContentStyle, DataGridListStyle } from "../../../Theme";
import { v4 as uuid } from "uuid";

const columnsPendingRefillsAllergyInfo: GridColDef[] = [
  {
    field: "drugName",
    headerName: " Drug Name	",
    minWidth: 450,
    cellClassName: "w50",
    headerClassName: "w50",
  },
  {
    field: "reactions",
    headerName: "Allergies",
    minWidth: 450,
    cellClassName: "w50",
    headerClassName: "w50",
  },
];

export default function PendingRefillsAllergyInfo(props: any) {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState<any>(10);

  const AllergiesState = useSelector((state: any) => {
    return { ...state.AllergiesSlice };
  }); //redux data

  const [rowCountState, setRowCountState] = useState(
    AllergiesState?.Pagination?.totalItems || 0
  );

  const getAllergiesData = (nextPage: number) => {
    let paramdata = {
      pageNumber: nextPage,
      patientId: props?.patientId,
    };
    dispatch(loadingAllAllergies(paramdata));
  };

  useEffect(() => {
    setRowCountState((prevRowCountState: any) =>
      AllergiesState?.Pagination?.totalItems !== undefined
        ? AllergiesState?.Pagination?.totalItems
        : prevRowCountState
    );
  }, [AllergiesState?.Pagination?.totalItems, setRowCountState]);

  useEffect(() => {
    getAllergiesData(page);
  }, [page]);
  return (
    <>
      <ContentStyle>
        <Grid
          container
          item
          xs={12}
          spacing={1}
          alignItems="top"
          justifyContent="center"
        >
          <Grid item xs={12}>
            <DataGridListStyle>
              <DataGrid
                rows={AllergiesState?.Items ?? []}
                headerHeight={36}
                sortingOrder={["desc", "asc"]}
                columns={columnsPendingRefillsAllergyInfo}
                autoHeight
                rowHeight={40}
                rowsPerPageOptions={[10]}
                disableSelectionOnClick
                getRowId={(row) => row.drugId ?? uuid()}
                loading={AllergiesState?.isLoading}
                components={{
                  NoRowsOverlay: NoRecords,
                  NoResultsOverlay: NoRecords,
                  ErrorOverlay: ErrorOverlay,
                }}
                error={AllergiesState?.error || undefined}
                page={page}
                pageSize={pageSize}
                onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
                rowCount={rowCountState}
              />
            </DataGridListStyle>
          </Grid>
        </Grid>{" "}
      </ContentStyle>
    </>
  );
}
